import { v4 as uuidv4 } from "uuid";

const manuallyGenerateCorrelationId = () =>
    Math.floor(4294967296 * Math.random())
        .toString(16)
        .padStart(8, "0");

export const generateCorrelationId = () => {
    if (typeof window?.crypto?.getRandomValues !== "undefined") {
        return uuidv4();
    }
    return manuallyGenerateCorrelationId();
}
